<template>
    <div class="flex flex-col overflow-hidden relative rounded-lg text-white">
        <button
            @click.stop.prevent="getResource($event, res)"
            tabindex="-1"
            class="group relative block h-32 overflow-hidden w-full at1024:h-[170px]"
        >
            <img
                :src="thumbnail"
                alt=""
                class="h-full w-full object-cover"
            />
            <span v-if="resourceTypeIcon === 'icon-movie'" class="sr-only">Open video</span>
            <span v-else class="sr-only">Open file</span>
            <span
                v-if="resourceTypeIcon === 'icon-movie'"
                class="duration-150 bg-black/5 group-hover:bg-transparent absolute inset-0 flex items-center justify-center"
            >
                <BaseSvg class="duration-150 w-12 h-12 group-hover:w-14 group-hover:h-14" name="icon-play-circle" aria-hidden="true" />
            </span>
        </button>

        <div class="absolute top-4 right-4">
            <BaseSvg
                :name="resourceTypeIcon"
                class="bg-white border border-gray-tier-1 fill-gray h-8 w-8 p-1 group-hover:fill-white rounded-full"
            />
        </div>

        <div class="flex flex-col grow bg-gray-800 p-[18px] relative font-medium">
            <div
                class="overflow-hidden text-gray-400 text-base"
                v-if="res.vendors[0].display_name || res.vendors[0].name"
            >
                {{ res.vendors[0].display_name ?? res.vendors[0].name}}
            </div>
            <button @click.stop.prevent="getResource($event, res)" class="leading-tight text-left text-lg at1024:leading-[27.6px] at1024:text-[23px]">
                <span class="line-clamp-2">{{ res.name }}</span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { BaseSvg } from "@/Components";
import { useAssetTransforms, useResources, useUser } from "@/Composables";

const { user } = useUser();
const { getResource, transformElasticSearchResource } = useResources();

const props = defineProps({
    resource: {
        type: Object,
        required: true,
    },
    elasticsearch: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const { marketingAssetPdfThumbnail, youTubeThumbnail } = useAssetTransforms();

const res = computed(() => {
    if (props.elasticsearch) {
        return transformElasticSearchResource(props.resource);
    } else {
        return props.resource;
    }
});

const thumbnail = computed(() => {
    switch (res.value.asset.source) {
        case 3:
            return marketingAssetPdfThumbnail(
                res.value.asset.external_id,
                "c_fill,g_north,h_500,w_1000"
            );
        case 4:
            return youTubeThumbnail(res.value.asset.external_id);
        default:
            return null;
    }
});

const resourceTypeIcon = computed(() => {
    switch (res.value.asset.source) {
        case 3:
            return "icon-draft-paper";
        case 4:
            return "icon-movie";
        default:
            return null;
    }
});
</script>

<style>
/* .vendor-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
} */
</style>
